// Libs
import React, { useState } from 'react';
import { Tooltip, Modal } from 'antd';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import * as Yup from 'yup';

// Own Libs
import { Button, FormSubmitButton, FormTextArea, MasterDetailForm, Row } from '@digital/ui';

//Api
import { dispensarSolicitacaoChancelaGJMinuta, ISasPropostaOrdemCompra } from '@app/api/sas/sasProposta';

//Files
import { editandoState, modalAcoesIdState } from '../atoms';
import { Visibility } from '@app/components';

//Utils
import { isObjNotEmpty, vtObjToFormData } from '@app/helpers/objHelper';
import ModalConfirmContentJustificativa from '@app/components/ModalConfirmContent/ModalConfirmContentJustificativa';

interface Props {
    sasProposta: ISasPropostaOrdemCompra;
}

export const ModalDispensarSolicitacaoChancelaGJMinuta = ({ sasProposta }: Props) => {
    const setModalAcoesId = useSetRecoilState(modalAcoesIdState);
    const editando = useRecoilValue(editandoState);

    const [exibirModal, setExibirModal] = useState(false);

    const handleCancel = () => {
        setExibirModal(false);
    };

    const handleCancelAndClose = () => {
        setExibirModal(false);
        setModalAcoesId('');
    };

    const handleSubmit = (values: any) => {
        const form = vtObjToFormData(values);

        if (editando.sasPropostaId == sasProposta.id) {
            Modal.confirm({
                title: <>{editando.justificativa}</>,
                content: <ModalConfirmContentJustificativa
                    texto='É necessário informar a justificativa para a alteração.'
                    setJustificativa={e => {
                        form.set('justificativaEdicao', e);
                    }}
                />,
                okText: 'Confirmar',
                cancelText: 'Cancelar',
                onOk: async (e) => {
                    form.append('editando', 'true');
                    return new Promise((resolve, reject) => {
                        dispensarSolicitacaoChancelaGJMinuta(sasProposta.id, form)
                            .then((data: any) => {
                                if (data && data.valid) {
                                    return resolve(true);
                                } else {
                                    if (data.notifications && data.notifications.length > 0) {
                                        const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                                            return c.property == 'justificativaEdicao';
                                        });
                                        if (erroJustificativaEdicao >= 0) {
                                            return reject(false);
                                        }
                                    }
                                }
                            })
                            .finally(handleCancelAndClose);
                    });
                },
                onCancel: () => { setModalAcoesId(''); }
            });
        } else {
            dispensarSolicitacaoChancelaGJMinuta(sasProposta.id, form)
                .then((data: any) => {
                    if (data && data.valid) {
                        handleCancelAndClose();
                    }
                });
        }
    };

    return (
        <>
            <Tooltip title="Dispensar Chancela">
                <Button icon='commons-cancel' onClick={() => { setExibirModal(true); }} />
            </Tooltip>

            <Visibility visible={exibirModal}>

                <Modal title={`Dispensar Chancela`} width='780px' visible={exibirModal} onCancel={handleCancel} footer={null} >
                    <Visibility visible={isObjNotEmpty(sasProposta) && exibirModal} >
                        <MasterDetailForm
                            key={`form_ModalDispensarSolicitacaoChancelaGJMinuta_${sasProposta.id}`}
                            actions={[
                                <Button title='fechar' type='link' onClick={() => handleCancel()} />,
                                <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />
                            ]}
                            validationSchema={
                                Yup.object().shape({
                                    justificativa: Yup.string().required(`O campo Justificativa é obrigatório.`)
                                })
                            }
                            initialValues={{
                                justificativa: sasProposta.justificativaDispensarSolicitacaoChancelaGJMinuta
                            }}
                        >
                            <Row>
                                <FormTextArea
                                    name='justificativa'
                                    label='Justificativa'
                                    span={12}
                                    rows={4}
                                    maxLength={2000}
                                />
                            </Row>
                        </MasterDetailForm>
                    </Visibility>
                </Modal>

            </Visibility>
        </>
    );
};